__turbopack_context__.v({
  "className": "inter_fcec89d4-module__GzEwQG__className",
});
